import { useState } from "react";
import { TroubleshootService } from "../../application/services/troubleshootService";

const troubleshootService = new TroubleshootService();

export const useTroubleshoot = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [troubleshootData, setTroubleshootData] = useState(null);

  const getTroubleshootByDateAndVmId = async (date, vmId) => {
    setLoading(true);
    setError(null);
    
    try {
      const result = await troubleshootService.getTroubleshootByDateAndVmId(date, vmId);
      
      if (result.success) {
        setTroubleshootData(result.data);
        return result.data;
      } else {
        setError(result.message);
        setTroubleshootData([]);
        return [];
      }
    } catch (err) {
      setError(err.message);
      setTroubleshootData([]);
      return [];
    } finally {
      setLoading(false);
    }
  };

  return {
    getTroubleshootByDateAndVmId,
    loading,
    error,
    troubleshootData,
  };
};